import { FeatureToggleConfig } from "@/config/featureToggleConfiguration";
import { TranslationKey } from "@/i18n/translationKeys";
import { i18n } from "@/i18n";
import DefaultLanguage from "@/i18n/translations/da-DK.json";

export class DomHelper {
    static setFaviconAndTitle(config: FeatureToggleConfig): void {
        document.title = i18n.global.t(TranslationKey.Title) ?? DefaultLanguage.title;
        const favicon = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
        if (favicon && config.favicon) {
            favicon.href = config.favicon;
        }
    }
}